import React from 'react'

import { Text } from '@mxenabled/mxui'

import { SxProps } from '@mui/material'
import Stack from '@mui/material/Stack'

import { Description } from '../..'
import { MiniDescription } from './MiniDescription'

import { Beat } from '../../../types/CommonBeat'

export interface ContentAndDescriptionProps {
  asteriskText?: string
  beat: Beat
  children?: React.ReactNode
  descriptionPlacement?: 'top' | 'bottom'
  hideDescription?: boolean
  isLoading?: boolean
  isMini?: boolean
  hasFullWidthImage?: boolean
  sx?: SxProps
}

export const ContentAndDescription: React.FC<ContentAndDescriptionProps> = ({
  asteriskText,
  beat,
  children,
  descriptionPlacement = 'bottom',
  hideDescription = false,
  isLoading = false,
  isMini = false,
  hasFullWidthImage,
  sx,
}) => {
  const renderDescription = () => {
    if (hideDescription || !beat.html_description) return null
    return isMini ? (
      <MiniDescription content={beat.html_description!} isLoading={isLoading} sx={sx} />
    ) : (
      <Description beat={beat} hasFullWidthImage={hasFullWidthImage} sx={sx} />
    )
  }

  return (
    <>
      {descriptionPlacement === 'top' && renderDescription()}
      {/* TODO: Used this here for styling margin for the MiniBeat/FullWidth Beat. This will be updated once we have a separate BaseCard in Pulse */}
      <Stack sx={{ alignItems: 'center', ...(hasFullWidthImage && isMini && { mx: -16 }) }}>
        {children}
      </Stack>
      {descriptionPlacement === 'bottom' && renderDescription()}
      {asteriskText && (
        <Text
          sx={{
            color: 'text.secondary',
            display: 'block',
            pr: 8,
            textAlign: 'right',
          }}
          variant="caption"
        >
          {asteriskText}
        </Text>
      )}
    </>
  )
}
